import { DocumentData } from "@king-ict/eupisi-ui/models";

export interface Notification{
    id: number;
    title: string;
    message: string;
    validFrom?: Date;
    putOnTop: boolean;
    isActive: boolean;
    roles: number[];
    attachments: DocumentData[];        
}
export function createNotification(): Notification {
    return {
        id: 0,
        title: "",
        message: "",
        validFrom: new Date(),
        putOnTop: false,
        isActive: true,
        roles: [] as number[],
        attachments: [] as DocumentData[]
    }
}